import { render, staticRenderFns } from "./ConstructionTypeField.vue?vue&type=template&id=95f9dc4a&scoped=true&"
import script from "./ConstructionTypeField.vue?vue&type=script&lang=js&"
export * from "./ConstructionTypeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f9dc4a",
  null
  
)

export default component.exports